export default function formatBeverlyWilshire(name) {
	if (/beverly wilshire/gi.test(name)) {
		return name.replace(
			/(beverly wilshire,)(?:( beverly hills,))? (a four seasons hotel)/gi,
			"$1$2 <span class='font-20'>$3</span>"
		);
	}
	return name;
}
